import { EllipsisHorizontalIcon } from "@heroicons/react/24/solid";
import {
  BookmarkBorder,
  CommentOutlined,
  Favorite,
  FavoriteBorder,
  Reply,
  ShareOutlined,
} from "@mui/icons-material";
import { Icon } from "@mui/material";
import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import eventService from "../../services/EventService";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import SectionVideos from "componentsTemplate/Sections/SectionVideos";
import SectionFotos from "components/fotos/SectionFotos";
import Comments from "components/comments/comments";
import Contact from "components/contact/contact";
import placeholder from "images/placeholder-small.png";
import Advertising from "components/ad/Advertising";


const EventDetail: React.FC = () => {
  const { eventId }: any = useParams();

  const [evento, setEvento]: any = useState(null);
  const [loading, setLoading] = useState(true);

  const [isLiked, setIsLiked] = useState(false);
  const [isComment, setIsComment] = useState(false);

  useEffect(() => {
    getEventDetail();
  }, []);

  const getEventDetail = async () => {
    setLoading(true); // start loading
    await eventService
      .getEventDetail(eventId)
      .then((response: any) => {
        setEvento(response.data);
        setIsLiked(response.data.is_liked);
        setIsComment(response.data.is_comment);
        setLoading(false);
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false); // end loading
      });
  };

  const isLikedPost = async () => {
    await eventService
      .likeEvent(evento.post_id)
      .then((response: any) => {
        setIsLiked(!isLiked);
        getEventDetail();
        //console.log("liked: ", response.data);
        //setEvento(response.data);
      })
      .catch((error: any) => {
        console.error(error);
      });
  };

  return (
    
      <div className="w-full h-full">
      {loading ? (
        <div className="my-20 lg:my-40 spinner border-primary-600"></div>
      ) : evento != null ? (
        <>
          <div className="w-full h-auto bg-primary-50 dark:bg-gray-400 mb-10 pt-10 lg:pt-20">
            <section>
              <div className="flex flex-col lg:flex-row text-justify items-center bg-white dark:bg-gray-600 rounded-3xl mx-4 lg:mx-[16vw] shadow-2xl px-4 lg:px-8 py-4 lg:py-5">
                <div className="lg:w-72 sm:w-40 lg:mr-8">
                  <img
                    alt=""
                    className="rounded-lg md:rounded-full lg:h-52 lg:w-52 object-cover sm:w-32 sm:h-32 shadow-lg md:shadow-2xl md:shadow-gray-700"
                    src={
                      process.env.REACT_APP_BACKEND_API_URL +
                      "/storage/images/posts/events/logos/" +
                      evento.logo_path
                    }
                    onError={(e) => (e.currentTarget.src = placeholder)}
                  />
                </div>
                <div className="w-full">
                  <div className="flex flex-col lg:flex-row justify-between">
                    <div className="mb-4 lg:mb-0">
                      <span className="text-gray-400 text-sm">
                        {format(
                          parseISO(evento.initial_date),
                          "d 'de' MMMM, yyyy",
                          {
                            locale: ptBR,
                          }
                        )}
                      </span>
                    </div>

                    <div className="flex gap-2 flex-wrap">
                      {evento.address?.state && (
                        <span className="bg-primary-600 text-white text-xs font-medium px-3 py-0.5 rounded-full dark:bg-slate-700 cursor-pointer">
                          {evento.address?.state}
                        </span>
                      )}

                      {evento.address?.city && (
                        <span className="bg-primary-400 text-white text-xs font-medium px-3 py-0.5 rounded-full dark:bg-slate-700 cursor-pointer">
                          {evento.address?.city}
                        </span>
                      )}

                      <span className="bg-primary-600 text-white text-xs font-medium px-3 py-0.5 rounded-full dark:bg-slate-700">
                        {evento.category.name}
                      </span>
                      <span className="bg-primary-400 text-white text-xs font-medium px-3 py-0.5 rounded-full dark:bg-slate-700 ">
                        {evento.subcategory.name}
                      </span>
                    </div>
                  </div>

                  <p className="my-3 lg:text-4xl text-left sm:text-lg font-semibold">
                    {evento.name}
                  </p>

                  <p className="text-lg text-justify">{evento.descritpion}</p>

                  <div className="flex w-full items-center gap-x-4 mt-5">
                    <button
                      onClick={() => isLikedPost()}
                      className="rounded-full h-12 px-6 bg-primary-600 text-white hover:bg-primary-300 shadow-sm"
                    >
                      {
                        isLiked ? (
                          <Icon
                            component={Favorite}
                            fontSize="medium"
                            className="mr-2"
                            style={{ color: "white" }}
                          />
                        ) : (
                          <Icon
                            component={FavoriteBorder}
                            fontSize="medium"
                            className="mr-2"
                            style={{ color: "white" }}
                          />
                        )
                      }
                      {evento?.likes_count ?? 0}
                    </button>
                    <button className="rounded-full h-12 px-6 bg-primary-600 text-white hover:bg-primary-300 shadow-sm">
                      <Icon
                        component={CommentOutlined}
                        fontSize="medium"
                        className="mr-2"
                      />
                      {evento?.comments_count ?? 0}
                    </button>
                    {/* <div className="border-l-2 border-gray-300 h-6 w-[1px]"></div>
                    <div className="flex justify-center items-center h-12 w-12 bg-primary-600 rounded-full shadow-md hover:bg-primary-300 cursor-pointer">
                      <Icon
                        className="text-white"
                        component={BookmarkBorder}
                        fontSize="medium"
                      />
                    </div>
                    <div className="flex justify-center items-center h-12 w-12 bg-primary-600 rounded-full shadow-md hover:bg-primary-300 cursor-pointer">
                      <Icon
                        className="text-white"
                        component={ShareOutlined}
                        fontSize="medium"
                      />
                    </div>
                    <div className="flex justify-center items-center h-12 w-12 bg-primary-600 rounded-full shadow-md hover:bg-primary-300 cursor-pointer">
                      <Icon
                        className="text-white"
                        component={EllipsisHorizontalIcon}
                        fontSize="medium"
                      />
                    </div> */}
                  </div>
                </div>
              </div>
            </section>{" "}
            <br /> <br />
          </div>

          <div className="mx-[16vw] mb-10">
            <span className="w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">
              <Link to={"/"}>Home</Link> &gt;{" "}
              <Link to={"/eventos"}>Eventos</Link>&gt;{" "}
              <Link to={""}> {evento.name}</Link>
            </span>
          </div>

          <div className="desktop-margin flex flex-col lg:flex-row gap-x-8 px-8 sm:px-0 overflow-hidden w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[79rem] justify-between">
            <div className="w-full pt-10">
              <div className="mb-10">
                <p
                  className="text-justify"
                  dangerouslySetInnerHTML={{ __html: evento.description }}
                ></p>
              </div>
            </div>
            <div className="flex flex-1 flex-col h-fit items-center lg:items-end pt-5 gap-y-10">
              {evento.length != 0 ? (
                <div className="flex rounded-full w-full h-full" style={{paddingLeft: '30px'}}>
                  <div className="rounded-full h-full w-12 object-cover">
                    <img
                      alt=""
                      className="rounded-full w-[2.5rem] h-[2.5rem] object-cover"
                      src={
                        process.env.REACT_APP_BACKEND_API_URL +
                        "/storage/users/" +
                        evento.post.user.avatar_path
                      }
                      onError={(e) => (e.currentTarget.src = placeholder)}
                    ></img>
                  </div>
                  <div className="mx-2 items-center">
                    <div className="flex justify-between items-center">
                      <div className="flex-col justify-between items-center">
                        <div className="">
                          <div>
                            <span className="text-gray-600 font-medium mb-[-18px]">
                              {evento.post.user.display_name}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              {evento?.video_url && (
                <div
                  className="w-full h-[12rem] sm:w-full sm:h-[20rem] md:w-[40rem] md:h-[23rem] lg:w-full lg:h-[16rem] border-[#F8F8F8] dark:border-[#1D2432] rounded-3xl overflow-hidden pl-0 md:pl-[30px]"
                >
                  <iframe
                    className="border-[#F8F8F8] dark:border-[#1D2432] rounded-3xl border-8"
                    width="100%"
                    height="100%"
                    src={evento.video_url}
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  ></iframe>
                </div>
              )}

              <Contact post_type_id={2} post_id={evento.post_id} />
            </div>
          </div>

          {evento?.attachments?.length > 0 && (
            <div className="desktop-margin mb-10">
              <div className=" w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] px-3 md:px-0">
                <SectionFotos
                  attachments={evento?.attachments}
                  className="py-16 lg:py-28"
                />
              </div>
            </div>
          )}

          <Comments
            dados={evento}
            tela="evento"
            url="/posts/events/comment"
            urlAnswer="/posts/events/answer"
            get={getEventDetail}
          />

          <div className="mx-4 lg:mx-[16vw] my-10">
            <Advertising type="horizontal" categoryId={evento.category_id} />
          </div>
        </>
      ) : (
        <div className="bg-primary-200 border shadow rounded-3xl w-100 p-8">
          Nenhum evento encontradao
        </div>
      )}
    </div>

  );
};

export default EventDetail;
